(function () {
  // ---------------------------------------------------------------
  // 1) Lecture de la vidéo au survol de la carte
  // ---------------------------------------------------------------
  document.addEventListener('mouseover', function (e) {
    var fig = e.target.closest && e.target.closest('figure');
    if (!fig) return;
    var video = fig.querySelector('.product-card-video');
    if (!video) return;
    // on entre vraiment dans la figure (et pas un déplacement interne)
    if (fig.contains(e.relatedTarget)) return;

    if (video.preload === 'none') video.preload = 'auto';
    var p = video.play();
    if (p && p.catch) p.catch(function () {}); // ignore l'erreur si pas de focus
  });

  document.addEventListener('mouseout', function (e) {
    var fig = e.target.closest && e.target.closest('figure');
    if (!fig) return;
    var video = fig.querySelector('.product-card-video');
    if (!video) return;
    if (fig.contains(e.relatedTarget)) return; // on est encore dans la figure

    video.pause();
    video.currentTime = 0; // repart du début → réaffiche le poster
  });

  // ---------------------------------------------------------------
  // 2) Survol d'une pastille couleur sur une carte vidéo
  //    → afficher l'image associée à la variante par-dessus la vidéo
  // ---------------------------------------------------------------
  document.addEventListener('mouseover', function (e) {
    var swatch = e.target.closest && e.target.closest('.product-card .check.color li[data-img]');
    if (!swatch) return;

    var card = swatch.closest('.product-card');
    var fig = card && card.querySelector('figure.video-available');
    if (!fig) return; // carte sans vidéo → on laisse le thème gérer

    var img = fig.querySelector('.product-card-variant-img');
    if (!img) return;

    var src = (swatch.getAttribute('data-img') || '').trim(); // trim : le data-img a un retour à la ligne
    if (!src) return;

    if (img.getAttribute('src') !== src) img.setAttribute('src', src);
    img.classList.add('is-active');
  });

  document.addEventListener('mouseout', function (e) {
    var swatch = e.target.closest && e.target.closest('.product-card .check.color li[data-img]');
    if (!swatch) return;
    if (swatch.contains(e.relatedTarget)) return; // déplacement interne à la pastille

    var card = swatch.closest('.product-card');
    var fig = card && card.querySelector('figure.video-available');
    if (!fig) return;

    var img = fig.querySelector('.product-card-variant-img');
    if (img) img.classList.remove('is-active');
  });
})();